export const InoutVI = {
  "reasonInout": {
    "title": "Lý do check in/check out",
    "breadCrumb": "Quản lý check in/check out",
    "pageHeader": {
      "reasonInout": "Quản lý check in/check out"
    }
  }
}
